import { useQuery } from '@apollo/client'
import { graphql } from '~publish/graphql'
import type { Channel, ChannelGroup } from '~publish/gql/graphql'

export const GetChannelGroups = graphql(/* GraphQL */ `
  query GetChannelGroups($input: ChannelGroupsInput!) {
    channelGroups(input: $input) {
      ... on ChannelGroupsResponse {
        channelGroups {
          id
          name
          accountId
          createdAt
          organizationId
          updatedAt
          channelCount
          channels {
            id
            name
            avatar
            type
            service
          }
        }
      }
    }
  }
`)

export type ChannelGroup_Channel = Pick<
  Channel,
  'id' | 'name' | 'avatar' | 'type' | 'service'
>

export type ChannelGroup_ChannelGroup = Omit<ChannelGroup, 'channels'> & {
  channels: ChannelGroup_Channel[] | null
}

export const useChannelGroups = ({
  accountId,
  organizationId,
}: {
  accountId: string
  organizationId: string
}): {
  channelGroups: ChannelGroup_ChannelGroup[] | null
  loading: boolean
  error: boolean
} => {
  const { data, loading, error } = useQuery(GetChannelGroups, {
    variables: {
      input: {
        accountId,
        organizationId,
        limit: null,
      },
    },
    skip: !accountId || !organizationId,
  })

  if (
    !data?.channelGroups ||
    data.channelGroups.__typename !== 'ChannelGroupsResponse'
  ) {
    return {
      channelGroups: null,
      loading,
      error: !!error,
    }
  }

  const channelGroups = data.channelGroups.channelGroups

  return {
    channelGroups,
    loading,
    error: !!error,
  }
}
